import { EventEmitter } from 'eventemitter3';
import { Report } from '../model/Report';
import { ModelDataUpdate, AuthenticationDataUpdate } from '../Events';
import { Cadastre } from '../model/Cadastre';
import { Affair } from '../model/Affair';
import { Building } from '../model/Building';
import { HousingValue } from '../model/HousingValue';
import { Ownership } from '../model/Ownership';
import { Token } from '../realty/model/Token';

export class DataStore extends EventEmitter {
  private report: Report;
  private cadastre: Cadastre;
  private affairs: Affair[] = [];
  private buildings: Building[] = [];
  private housingValue: HousingValue;
  private surroundingHousingValues: HousingValue[] = [];
  private ownerships: Ownership[] = [];

  private authenticationData: Token;

  public getReport(): Report {
    return this.report;
  }

  public getCadastre(): Cadastre {
    return this.cadastre;
  }

  public getBuildings(): Building[] {
    return this.buildings;
  }

  public getSurroundingHousingValues(): HousingValue[] {
    return this.surroundingHousingValues;
  }

  public getOwnerships(): Ownership[] {
    return this.ownerships;
  }

  public storeAmbitaHousingValueReport(report: Report): void {
    this.cadastre = this.affairs = this.buildings = undefined;
    this.housingValue = this.ownerships = this.surroundingHousingValues = undefined;
    this.report = report;
    if (report) {
      this.cadastre = report.cadastre;
      this.affairs = report.affairs;
      this.buildings = report.buildings;
      this.housingValue = report.housingValue;
      this.ownerships = report.ownerships;
      this.surroundingHousingValues = report.surroundingHousingValues;
    }
    this.emit(ModelDataUpdate);
  }

  public getAuthenticationData(): Token {
    return this.authenticationData;
  }

  public setAuthenticationData(authenticationData: Token): void {
    this.authenticationData = authenticationData;
    this.emit(AuthenticationDataUpdate);
  }
}

export default new DataStore();



/** WEBPACK FOOTER **
 ** ./src/stores/DataStore.ts
 **/